import { IParent, IParentParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const parentsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_parents: builder.query<ITableRes<IParent>, IParentParams>({
      query: (params) => ({
        url: '/parents/',
        params,
      }),
      providesTags: ['parents'],
    }),
    GET_parentById: builder.query<IParent, string>({
      query: (id) => {
        return {
          url: `/parents/${id}/`,
        }
      },
      providesTags: ['parent'],
    }),
    POST_parent: builder.mutation<IParent, IParent>({
      query: (body) => ({
        url: `/parents/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['parent', 'parents'],
    }),
    PUT_parent: builder.mutation<IParent, { id: string; body: IParent }>({
      query: ({ id, body }) => ({
        url: `/parents/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['parents', 'parent'],
    }),
    DELETE_parent: builder.mutation<IParent, string>({
      query: (id) => ({
        url: `/parents/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['parents'],
    }),
  }),
})

export const {
  useGET_parentsQuery,
  useGET_parentByIdQuery,
  usePOST_parentMutation,
  usePUT_parentMutation,
  useDELETE_parentMutation,
} = parentsAPI
